import asyncComponent from '../../components/AsyncComponent';

const CourseCreate = asyncComponent(() => import('../../components/Course/Create'));

export default CourseCreate;
